import React, { Component } from "react";
import {
  InputControl,
  validateRequired,
  validateEmail,
  validatePassword
} from "wvus-forms";

import {createCiamUser} from "../lib/requests";
import {UNEXPECTED_ERROR} from '../lib/messages';


class CreateCiamAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      submissionError: false,
      loading: false
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    // fail safe to bail if they get around disabled button
    if (!this.props.formMethods.isFormValid()) return false;

    const password = this.props.formMethods.getFieldState(
      "wv-create-account-form-pass"
    ).value;

    createCiamUser(this.props.supporterEmail, password)
      .then(response => {
        if(!response.data) {
          throw new Error();
        }

        const responseData = response.data;

        if (!responseData.success) {
          const message =
          responseData.statusCode && responseData.error && responseData.message
              ? `Code: ${responseData.statusCode}, Error: ${
                responseData.error
                }, Message: ${responseData.message}`
              : "An error occurred";
          throw new Error(message);
        }
        // Show Confirmation form
        this.props.setForm("Confirmation", this.props.supporterEmail);
      })
      .catch(response => {
        this.setState({
          errorMessage: UNEXPECTED_ERROR,
          submissionError: true
        });
      });
  }

  render() {
    const { formMethods, supporterEmail } = this.props;
    const { loading, submissionError, errorMessage } = this.state;
    const submitDisabled = !formMethods.isFormValid() || loading;

    const loadingIcon = loading ? (
      <span>
      <i className="fa fa-spinner fa-pulse fa-fw" />
      <span className="sr-only">Loading...</span>
      </span>
    ) : (
      ""
    );

    return (
      <form
        id="wv-create-ciam-account-form"
        className="wv-create-ciam-account-form wvus-form"
      >
        {submissionError && (
          <p className="wv-create-account-error-message error-message" role="alert" aria-live="assertive">
            {errorMessage}
          </p>
        )}
        <InputControl
          isValid={true}
          fieldValue={supporterEmail}
          fieldName="wv-create-account-form-user"
          fieldTitle="Signing in as"
          fieldClasses="wv-create-account-form-user"
          formMethods={formMethods}
          validators={[validateRequired, validateEmail]}
          attributes={{ readOnly: true, disabled: true }}
        />

        <InputControl
          fieldName="wv-create-account-form-pass"
          fieldTitle="Create a password"
          fieldType="password"
          fieldClasses="wv-create-account-form-pass"
          formMethods={formMethods}
          validators={[validateRequired, validatePassword]}
        />
        <p className="create-account__password-hint">
          At least 8 characters with a number, an uppercase letter, and a lowercase letter.
        </p>

        <button
          type="submit"
          id="wv-create-account-form-submit"
          className="btn btn-medium btn-primary create-account__submit"
          disabled={submitDisabled}
          onClick={this.handleFormSubmit}
        >
          {loadingIcon} Create Account
        </button>
      </form>
    );
  }
}
export { CreateCiamAccount };
